import Typography, { type TypographyProps } from "@mui/material/Typography";

export const IdentityPlaceholderTitle = (props: TypographyProps) => (
    <Typography
        variant='subtitle2'
        {...props}
    >
        Drop or Select a file (PNG, JPEG, PDF)
    </Typography>
);

export const IdentityWithExcelPlaceholderTitle = (props: TypographyProps) => (
    <Typography
        variant='subtitle2'
        {...props}
    >
        Drop or Select a file (PNG, JPEG, PDF, XLS)
    </Typography>
);
